var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasVersions)?_c('ul',_vm._l((_vm.orderedVersions),function(version,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(version.message)+" ")])}),0):_c('p',[_vm._v("Sem histórico registado até ao momento")])])
}
var staticRenderFns = []

export { render, staticRenderFns }